import { render, staticRenderFns } from "./GameLink.vue?vue&type=template&id=b481983e"
import script from "./GameLink.vue?vue&type=script&lang=js"
export * from "./GameLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports